import parseDateYmd from "lib/utils/parseDateYmd";
import type { IntlShape } from "react-intl";

export default function formatDateOrReturnHyphen(intl: IntlShape, value: string | undefined) {
  if (!value) {
    return "-";
  }

  return intl.formatDate(parseDateYmd(value), {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  });
}
